import React from 'react'
import QRCode from 'qrcode.react';

const QRCodeBox = (props) => {
  return (
    <QRCode value={props.shortenUrl} renderAs='canvas' />
  )
}

export default QRCodeBox


// WEBPACK FOOTER //
// ./src/components/QRCodeBox/QRCodeBox.js